<template>
  <el-card shadow="hover" class="x-card-title-slot shop-management">
    <div class="row no-gutters align-items-center" slot="header">
      <div class="col header-title">
        <el-tabs-tabs v-if="has_intelligent_card20" :active.sync="activeTabName" :tabs="hasPackageStore === 1 ?
          [{ label: '现金商城', name: 'cashShop' }, { label: '套餐卡商城', name: 'comboCardShop' }, { label: 'AI智能套餐卡应用', name: 'comboCardShop2' }] :
          [{ label: '现金商城', name: 'cashShop' }, { label: 'AI智能套餐卡应用', name: 'comboCardShop2' }]" />
        <el-tabs-tabs v-else :active.sync="activeTabName" :tabs="hasPackageStore === 1 ?
          [{ label: '现金商城', name: 'cashShop' }, { label: '套餐卡商城', name: 'comboCardShop' }] :
          [{ label: '现金商城', name: 'cashShop' }]" />
      </div>

      <!--      <el-switch-->
      <!--        style="margin-right: 12px"-->
      <!--        v-model="sortType"-->
      <!--        @change="sortTypeChange"-->
      <!--        active-text="正序"-->
      <!--        inactive-text="倒序">-->
      <!--      </el-switch>-->

      <el-button v-if="activeTabName === 'cashShop'" @click="addCashShop" type="primary" size="small"
        :disabled="storeNum !== -1 && storeNum <= listData.length">
        新增现金商城
      </el-button>
      <el-button v-else @click="addComboCardShop(activeTabName === 'comboCardShop2' ? 2 : 1)" type="primary" size="small"
        :disabled="activeTabName === 'comboCardShop' && packageStoreNum !== -1 && packageStoreNum <= listData.length">
        新增套餐卡商城
      </el-button>
    </div>

    <div class="shoppingList">
      <div v-for="(item, index) in listData" :key="item.id" class="shopingItem">
        <div class="online-tag" :class="item.shop_disable === 'OPEN' ? '' : 'disable'">
          {{ item.shop_disable === 'OPEN' ? '已上线' : '已下线' }}
        </div>
        <div v-if="item.isCoping" class="is-coping-overlay">
          数据同步中<span id="spinner">...</span>
        </div>
        <div v-if="isCoping" class="is-coping-progress-bar"></div>
        <div>
          <div class="top">
            <div class="img">
              <img v-if="item.company_img" :src="item.company_img" alt />
              <!-- <img v-else src="../../assets/logo_images/icon-noface.jpg" alt=""> -->
            </div>
            <div v-if="item.isQr" class="qr">
              <img :src="item.qrcode" alt />
              扫码查看商城
            </div>
          </div>
          <div class="bot">
            <div class="tit">{{ item.shop_name }}</div>
            <div class="sub-tit" v-if="item.shop_createtime">起至时间：{{ item.shop_createtime | unixToDate('yyyy-MM-dd') }} -
              {{ item.level_duetime | unixToDate('yyyy-MM-dd') }}
            </div>
            <div class="sub-tit" v-else>起至时间：暂无数据
            </div>
            <div class="statics-wrap">
              <div class="statics-item">
                <div>昨日交易</div>
                <div>{{ Number(item.sum_price) }}</div>
              </div>
              <template v-if="activeTabName === 'cashShop'">
                <div class="statics-item">
                  <div>昨日访客</div>
                  <div>{{ Number(item.uvn) }}</div>
                </div>
                <div class="statics-item">
                  <div>昨日浏览</div>
                  <div>{{ Number(item.pvn) }}</div>
                </div>
              </template>
              <template v-else>
                <div class="statics-item">
                  <div>已激活总数</div>
                  <div>{{ Number((typeof item.active_num) === 'undefined' ? 0 : item.active_num) }}</div>
                </div>
                <div class="statics-item">
                  <div>已兑换总数</div>
                  <div>{{ Number((typeof item.binding_num) === 'undefined' ? 0 : item.binding_num) }}</div>
                </div>
              </template>
            </div>
            <!-- <div class="text">
              <span class="qrcodeIcon" @mouseenter="qrEnter(index)" @mouseleave="qrLeave(index)">
                <img :src="item.qrcode" alt />
              </span>
              <span @click="preview(item)" class="btn">预览</span>
            </div> -->
          </div>
          <div class="bot bot-btns">
            <div class="btns-wrap">
              <div v-if="activeTabName === 'comboCardShop2'" class="btns-item">
                <el-switch v-model="item.after_sale_check" style="width: 40px;" :active-value="1" :inactive-value="0"
                  @change="handleSwitchChange(item)"></el-switch>
                <div>商城售后审核</div>
              </div>
              <div v-if="activeTabName === 'cashShop'" class="btns-item" @mouseenter="qrEnter(index)"
                @mouseleave="qrLeave(index)">
                <div><img :src="iconQrcode" alt="" /></div>
                <div>二维码</div>
              </div>
              <div v-if="activeTabName === 'cashShop'" class="btns-item" @click="preview(item)">
                <div><img :src="iconView" alt="" /></div>
                <div>浏览</div>
              </div>
              <div class="btns-item" @click="copyShop(item)">
                <div><img :src="iconCopy" alt="" /></div>
                <div>复制</div>
              </div>
              <div class="btns-item" @click="manageProject(item)">
                <div><img :src="iconManage" alt="" /></div>
                <div>管理</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog class="dia" top="2vh" :visible.sync="mallPreviewShow" :close-on-click-modal="false"
      :close-on-press-escape="false" append-to-body width="60%" height="80%" title="店铺预览（预览效果仅供参考，请以实际设备运行为准。）">
      <div class="mall-wrap">
        <iframe class="mall-preview" :src="mallPreviewLink"></iframe>
      </div>
      <!-- <div slot="footer" class="text-picker-footer">
        <el-button @click="mallPreviewShow = false">关 闭</el-button>
      </div>-->
    </el-dialog>

    <el-dialog :before-close="handleBeforeClose" custom-class="copy-dialog" :visible.sync="copyDialogVisible"
      :close-on-click-modal="false" :close-on-press-escape="false" append-to-body width="60%" title="复制商城">
      <div class="form">
        <div class="content">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
            <el-form-item label="商城名称" prop="shop_name">
              <el-input v-model="ruleForm.shop_name" @input="genDomainName"></el-input>
            </el-form-item>

            <!--            <el-form-item-->
            <!--              label="商城类型"-->
            <!--              prop="mall_type"-->
            <!--            >-->
            <!--              <el-radio-group-->
            <!--                v-model="ruleForm.mall_type"-->
            <!--                v-if="activeTabName==='cashShop'"-->
            <!--              >-->
            <!--                <el-radio label="2">现金商城</el-radio>-->
            <!--              </el-radio-group>-->
            <!--              <el-radio-group-->
            <!--                v-model="ruleForm.mall_type"-->
            <!--                v-else-->
            <!--              >-->
            <!--                <el-radio label="3">套餐卡商城</el-radio>-->
            <!--              </el-radio-group>-->
            <!--            </el-form-item>-->

            <el-form-item label="站点域名" prop="domain_name"
              v-if="activeTabName === 'cashShop' || activeTabName === 'comboCardShop2'">
              <el-input v-model="ruleForm.domain_name">
                <template v-if="activeTabName === 'cashShop'" slot="prepend">https://</template>
                <template v-else slot="prepend">https://ai-</template>
                <template slot="append">{{ $url }}</template>
              </el-input>
            </el-form-item>

            <el-form-item label="默认地区" prop="region"
              v-if="activeTabName === 'cashShop' || activeTabName === 'comboCardShop2'">
              <x-address-select :value.sync="ruleForm.regionValue" />
            </el-form-item>

            <el-form-item label="站点负责人" prop="link_name">
              <el-input v-model="ruleForm.link_name"></el-input>
            </el-form-item>

            <el-form-item label="负责人联系方式" prop="link_phone">
              <el-input v-model="ruleForm.link_phone"></el-input>
            </el-form-item>

            <el-form-item label="站点账号" prop="mobile">
              <template>
                <el-input type="text" v-model="ruleForm.mobile"></el-input>
                <el-input type="text" style="position: fixed; bottom: -9999999px"></el-input>
              </template>
            </el-form-item>

            <el-form-item label="站点初始密码" prop="password">
              <el-input type="password" style="position: fixed; bottom: -9999999px"></el-input>
              <el-input type="password" v-model="ruleForm.password"></el-input>
            </el-form-item>

            <!-- <el-form-item
              label="登陆方式"
              prop="integer"
              v-if="activeTabName==='cashShop'"
            >
              <el-radio-group v-model="ruleForm.integer">
                <el-radio label="1">手机号+密码</el-radio>
                <el-radio label="2">手机号+验证码</el-radio>
              </el-radio-group>
            </el-form-item> -->

            <el-form-item label="站点状态" prop="shop_disable">
              <el-radio-group v-model="ruleForm.shop_disable">
                <el-radio label="OPEN">启用</el-radio>
                <el-radio label="CLOSED">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="text-picker-footer">
        <el-button size="small" @click="handleBeforeClose">关 闭</el-button>
        <el-button size="small" type="primary" @click="handleCopyShop">确 定</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import md5 from "js-md5";
import * as API_MallManageMent from "@/api/mallManagement";
import * as API_Shop from "@/api/shop";
import ElTabsTabs from "@/components/ElTabsTabs";
import { Component, Vue, Watch } from "vue-property-decorator";
import {
  validatePhone,
  validateLowerCaseAndNumber,
  validateAlphabetsAndNumber,
} from "@/utils/validate";
import { pinyin } from "pinyin-pro";
import XAddressSelect from "../../../../components/x-address-select/x-address-select";
// import Storage from "../../../../utils/storage";

const shopNameValidator = (rule, value, callback) => {
  if (!value) {
    callback(new Error("请输入商城名称"));
  }
  if (!/[A-Za-z0-9\u4e00-\u9fa5]$/.test(value)) {
    callback(new Error("请输入中英文商城名称"));
  }
  callback();
};
const phoneValidator = (rule, value, callback) => {
  if (!value) {
    callback(new Error("请输入联系方式"));
  }
  if (!validatePhone(value)) {
    callback(new Error("请输入正确的手机号码"));
  }
  callback();
};
const phoneValidator1 = (rule, value, callback) => {
  if (!value) {
    callback(new Error("请输入站点账号"));
  }
  if (!validatePhone(value)) {
    callback(new Error("请输入正确的手机号码作为站点账号"));
  }
  callback();
};
const accountValidator = (rule, value, callback) => {
  if (!value) {
    callback(new Error("请输入站点账号"));
  }
  if (
    !validateAlphabetsAndNumber(value) ||
    value.length < 6 ||
    value.length > 20
  ) {
    callback(
      new Error("最少6位，最多20位。只能是数字、字母，字母区分大小写。")
    );
  }
  callback();
};
const lowerCaseValidator = (rule, value, callback) => {
  if (!value) {
    callback(new Error("请补全网址"));
  }
  if (!validateLowerCaseAndNumber(value)) {
    callback(new Error("请输入小写字母或数字"));
  }
  if (value && value.length > 25) {
    callback(new Error("输入的最大长度为25个字符"));
  }
  callback();
};

@Component({
  name: "shop-management",
  components: {
    XAddressSelect,
    ElTabsTabs,
  },
})
export default class ShopManagement extends Vue {
  headUrl = "https://";
  listData = [];
  mallPreviewShow = false;
  mallPreviewLink = "";
  copyDialogVisible = false;
  isCoping = false;
  copyTaskTimer = null;
  iconQrcode = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAABqlBMVEUAAAAAAACAgIBmZmZVVVVtbW1mZmZqampiYmJtbW1mZmZgYGBpaWlhYWFqampiYmJkZGRqamppaWlmZmZoaGhmZmZlZWVkZGRlZWVmZmZlZWVnZ2dlZWVnZ2dlZWVnZ2dnZ2dlZWVlZWVnZ2dmZmZlZWVnZ2dmZmZlZWVnZ2dnZ2dmZmZlZWVmZmZmZmZnZ2dmZmZlZWVnZ2dmZmZmZmZmZmZnZ2dmZmZlZWVmZmZmZmZnZ2dmZmZlZWVmZmZnZ2dmZmZlZWVmZmZnZ2dlZWVmZmZnZ2dmZmZlZWVmZmZnZ2dmZmZlZWVmZmZmZmZmZmZnZ2dmZmZlZWVmZmZnZ2dmZmZmZmZnZ2dmZmZlZWVmZmZmZmZmZmZmZmZmZmZmZmZnZ2dmZmZmZmZnZ2dmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmaqbS0ZAAAAjXRSTlMAAQIFBgcKDA0ODxARFRgaHB0iKCwtNTg6PD9DREVJSlJWW15fYGFkZWZoaWprbG1ub3JzdXZ3eHl6e3x9foCBgoOFhoiJi4yNjpCRkpObnZ+iq62ztre4ubq7vL7AwcbHyMvMzc7R0tPU1dbX2Nna29zd3t/i4+Tl5unr7e7v8PLz9PX29/j5+vv8/f7sQdK5AAABvUlEQVQYGX3BizeTcQDH4Y+1mZru6aqb5pKSLXuFicylKN0zjW5EU8PaO7NGtagwff/n3t9s5+Sc6nn4v95kNuOYPgc8SNcAA8lsJrO89KqWbpUdhS2FIKIyVjQZCAYDbV90C9bViPuHYoFgsLVLIiM/xqx6oW7Ex95N+TEKwlYII6EwRd68Qjj2FIQtCyOhMEXevCwc7oJI6xpGXN0UVa2pFaMgcurCWFQEPIfAW1AnDs+2iGs9mUol01ITvNw+TcVHfVtMpRYzEqe+a8drD+QVgDNb2vECDgc6LMtqv4TDVj1wJHjDsqz2Onaz5eef5nWWP50fvHO7ZHDoq8YHRu717IfK0N3Rm+gvLsMJOWgYfx4tGYuuaW4sOvHoIHhHJ2IP2eW9LrCbu9rnq/ZhzKsBw+NyVWAMrW5ubGz+/HARWFAjcD2eW85kP03W0q+yGlhQEzSr5Bcril1tabkS/Kw+yKsN4prucUQkluTHmFUPPM6dhFl1YcwksWVhJBQG3MCUhimxZWEkFGbHlIYpSasZ4526gUrgrfownr0hp0iVw2erH56sHoc53d/nwn1AYkZl9SB1wlNJx+iQ9BvNa64ewVGeJQAAAABJRU5ErkJggg==";
  iconView = "data:image/png;base64,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";
  iconCopy = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAeCAMAAAB61OwbAAABMlBMVEUAAAAAAACAgIBVVVVmZmZtbW1gYGBxcXFmZmZdXV1kZGRiYmJmZmZjY2NkZGRpaWljY2NlZWVpaWlmZmZnZ2dlZWVmZmZkZGRnZ2dmZmZnZ2dlZWVoaGhmZmZkZGRoaGhmZmZkZGRnZ2dnZ2dmZmZlZWVmZmZlZWVnZ2dmZmZlZWVlZWVmZmZlZWVmZmZlZWVlZWVmZmZmZmZlZWVmZmZnZ2dmZmZmZmZmZmZmZmZlZWVmZmZmZmZnZ2dmZmZlZWVnZ2dmZmZnZ2dmZmZmZmZnZ2dmZmZlZWVmZmZmZmZnZ2dmZmZlZWVmZmZlZWVmZmZmZmZlZWVmZmZnZ2dmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmaua6tMAAAAZXRSTlMAAQIDBQcICQoLFxoeHyEiJCYnKCorLS4vMjQ1Njc4Ozw9PkVGUVVYWVpbXV9iZGVqa25vdnd4en2EiIyOmqOrrq+ztLa4ubq7vL2+v8PExcbJyszNz93f4uvw8vT19vj5+vv9/vxpNBUAAAFJSURBVCjPjdNnV8IwFAbgAFJ3cU/QgquouMVRFRcgpeCoW5G28P7/v+CHhjRJ8RzfTzcnz2lvblpC/p+o8dp0mkGcz0KG348/IxyNAzto5NJaOsjiUhUvHCjhRH7pAMCtatij1ewqLQYFUEGeVk8Y84uEAEwG6shIYPuyYpAiAyaSAuh9BNAiNwwUMS4AA97pkU5KyBNC+hUlbkFTlL4eBj6w0elh5Jsb0gFRfQBMdk4x/AbPdVpwXReNrQ5w/IH6x1RisYiJVDQWD3poIi3OoYQJockQkI8ZAjVpUCFgS3Og4B67FMyvibdJwTXO5OseEsA62sdZPRtE37TxwIFIOfzFeTMcIGT/yqKp3lUsyyobfrMM/JUuIHlxyK3aSMkgh3du5WBaBiuoCx9jcUpVEyyqmrJxzoGFLn8URvkHLld/xN2v2zm2+QtvCHlryBu30QAAAABJRU5ErkJggg==";
  iconManage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAB5lBMVEUAAAAAAACAgIBVVVWAgIBVVVVtbW1gYGBxcXFmZmZdXV1qampiYmJgYGBpaWljY2Nra2thYWFkZGRqampmZmZoaGhkZGRmZmZjY2NoaGhkZGRpaWljY2NnZ2dpaWlnZ2dlZWVoaGhmZmZnZ2dlZWVkZGRnZ2dlZWVoaGhnZ2dlZWVoaGhmZmZkZGRnZ2dnZ2dlZWVnZ2dmZmZnZ2dlZWVlZWVnZ2dlZWVnZ2dmZmZlZWVnZ2dmZmZlZWVnZ2dnZ2dnZ2dlZWVnZ2dmZmZmZmZnZ2dlZWVmZmZnZ2dmZmZmZmZmZmZmZmZlZWVmZmZnZ2dmZmZlZWVlZWVmZmZnZ2dmZmZlZWVmZmZmZmZmZmZmZmZmZmZmZmZnZ2dmZmZmZmZmZmZnZ2dmZmZmZmZmZmZlZWVmZmZnZ2dmZmZnZ2dmZmZmZmZmZmZnZ2dmZmZlZWVmZmZmZmZmZmZmZmZnZ2dmZmZlZWVmZmZnZ2dmZmZlZWVmZmZnZ2dmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmal5xunAAAAoXRSTlMAAQIDBAYHCAkKCwwNEBESExUXGBkbHB4fICEiJCUnKissLS8wMzQ1Njk6Ozw9PkNERUZISUxNTk9QU1RVVldZXF1eZGxtb3Byc3V2eHl6fH1+g4WLjI2Oj5GTmJmanaCjpKeoqqutrq+ztLa3uLm6vL7AwcLDxMXHyMnKzM7Q09TX2Nna29zd3+Dh4uPk5ujp6uvt7/Lz9PX29/j5+vv9/uQ0ukUAAAH5SURBVBgZbcGJX4sBAMfh35RK0yFES7ootJCKocYciShnCUWEcqQioXJ0yJFq2pq2sO9/6n1fr1efPnse/bfm9uLyciwWW448yVQitTgalUiAGa+3srLSO0qzVsmQwce4LE85K0OGHDci3ZtVP0VIltfMn1Zye+SBbBVAuA9okMW3BEPTwAn9NcnQINCZL1vOFeBdD9EUmU5Bqi48PK4V9ndfl4J0ypAU55ISqoMtklpZkMNdWJQlxzj9UiH4Zcu7E4ZfvWWylcBhvWBINm8UYkuAX7abfNYM31pcMuXA1yNpKfveQLksDe+Ja88UjKbLcJ+ZTJleMiGDqxuCdZKaoEqSG2pk2Q7bJLmhwy1TnHJJxURlC1IrKTVEoSxxdkgqZUm2WQ5JWrtAiUxH49RIyoQyWTZBsaT10CJpax+EcmQY5K0s9/jukpQ0AqM7NUb4bq5MRfB8d7KrpAsOypR+a46QxnksWz0QnAWaZLvKog7we5dsVSMYJgOyZYc4I/XwQY6C6upiOfqZkLQBAkqoAnbJ0MpPyddWqhU2XjspTdAvkytERxvQmKZ/AmHoaoFcWY5h+AJzPlnKp2Eew2XZHkWH9yY1B5mTZYBI+7qC3tgrObJk8PNRlgHOy5CtVfx88njy8z2eYc4pET+Oi0rE/SyC5cdYnhx/AGqKyMIVcyL8AAAAAElFTkSuQmCC";
  ruleForm = {
    shop_name: "",
    mall_type: "2", // 商城类型1.积分商城（javashop遗留，未用到）;2现金商城;3,套餐卡商城
    domain_name: "",
    link_name: "",
    link_phone: "",
    mobile: "",
    password: "",
    integer: "2",
    shop_disable: "OPEN",
    regionValue: undefined,
    template: 1,
  };

  hasPackageStore = 0;
  has_intelligent_card20 = true;
  packageStoreNum = 0;
  storeNum = 0

  rules = {
    shop_name: [
      {
        required: true,
        validator: shopNameValidator,
        trigger: "blur",
      },
      {
        min: 3,
        max: 20,
        message: "长度在 3 到 20 个字符",
        trigger: "blur",
      },
    ],
    domain_name: [
      {
        required: true,
        validator: lowerCaseValidator,
        trigger: "blur",
      },
    ],
    link_name: [
      {
        required: true,
        validator: (rule, value, callback) => {
          if (!value) {
            callback(new Error("请输入负责人名称"));
          }
          if (!/^[\u4e00-\u9fa5]*$/.test(value)) {
            callback(new Error("请输入正确的负责人名称"));
          }
          callback();
        },
        trigger: "blur",
      },
      {
        min: 1,
        max: 10,
        message: "长度在 1 到 10 个字符",
        trigger: "blur",
      },
    ],
    link_phone: [
      {
        required: true,
        validator: phoneValidator,
        trigger: "blur",
      },
    ],
    mobile: [
      {
        required: true,
        validator: phoneValidator1,
        trigger: "blur",
      },
    ],
    password: [
      {
        required: true,
        message: "请输入站点初始密码",
        trigger: "blur",
      },
      {
        min: 6,
        max: 20,
        message: "长度在 6 到 20 个字符",
        trigger: "blur",
      },
    ],
  };

  activeTabName = "";

  @Watch("activeTabName")
  activeTabNameChange () {
    switch (this.activeTabName) {
      case "cashShop":
        this.ruleForm.mall_type = "2"
        break;
      case "comboCardShop":
        this.ruleForm.mall_type = "3"
        break;
      case "comboCardShop2":
        this.ruleForm.mall_type = "4"
        break;
      default:
        break;
    }
    this.getShopList();
    this.ruleForm.domain_name = '';
  }

  mounted () {
    switch (this.$route.query.combo) {
      case 1:
        this.activeTabName = "comboCardShop"
        break;
      case 2:
        this.activeTabName = "comboCardShop2"
        break;
      default: this.activeTabName = "cashShop"
        break;
    }
    this.rules.mobile[0].validator = accountValidator
    API_Shop.getShopLv().then(res => {
      this.hasPackageStore = res.data.has_package_store
      this.packageStoreNum = res.data.package_store_num
      this.has_intelligent_card20 = res.data.has_intelligent_card20 === 1
      console.log(this.packageStoreNum)
      this.storeNum = res.data.store_num
    })
  }

  destroyed () {
    clearInterval(this.copyTaskTimer);
  }

  getShopList () {
    const apiKey1 = this.activeTabName !== "comboCardShop2"
      ? "getMalllManageMentList"
      : "getComboShopList";

    API_MallManageMent[apiKey1]({ mall_type: this.activeTabName === "cashShop" ? 2 : 3 })
      .then((res) => {
        const data = res;

        data.forEach((item, index) => {
          data[index]["isQr"] = false;
        });

        const apiKey2 = this.activeTabName === "cashShop"
          ? "checkCopyShop"
          : "checkCopyShopCombo";

        API_MallManageMent[apiKey2]().then((res2) => {
          if (!res2) {
            data[data.length - 1]["isCoping"] = true;
          }

          this.listData = JSON.parse(JSON.stringify(data));
          // this.listData = listData.sort((a, b) => a.id - b.id);
          for (let i = 0; i < this.listData.length; i++) {
            for (let j = i + 1; j < this.listData.length; j++) {
              if (Number(this.listData[i]['sum_price']) === Number(this.listData[j]['sum_price']) && this.listData[i]['shop_id'] > this.listData[j]['shop_id']) {
                const t = this.listData[i]
                this.listData[i] = this.listData[j]
                this.listData[j] = t
              }
            }
          }

          this.loadCopyTask();
        });
      })
      .catch(() => {
      });
  }

  addCashShop () {
    API_Shop.checkShopLv().then(res => {
      if (res.data.isStore === "1") {
        this.$router.push({ path: "/application/mallManagementEdit" });
      } else {
        this.$message.error(
          "您的企业创建商城数已达到上限，如想增加商城数，请先进行企业升级"
        );
      }
    });
  }

  addComboCardShop (type) {
    this.$router.push({ name: "comboCardShopEdit", query: { type } });
  }

  qrEnter (index) {
    this.listData[index].isQr = true;
  }

  qrLeave (index) {
    this.listData[index].isQr = false;
  }

  /** 修改智能套餐卡的生成售后审核状态 */
  handleSwitchChange (item) {
    const params = {
      switch_value: item?.after_sale_check,
      shop_id: item.shop_id
    }
    API_MallManageMent.changeAIComboShopAfterSaleStatus(params).then(() => {
      this.$message.success('修改成功')
    })
  }

  manageProject (item) {
    // 管理项目
    console.log(item, 'manageProject')
    API_MallManageMent.loginChild(item.shop_id).then((res) => {
      // let url;
      // if (/^[0-9].*[0-9]$/.test(location.host)) {
      //   url = `${location.protocol}//${location.host}/floor-preload?tokens=${res.access_token}`;
      // } else {
      //   if (this.activeTabName === "cashShop") {
      //     url = `${location.protocol}//${location.host.includes("testtwo") ? "testtwocompany.sshlqf.com" : (location.host.includes("test") ? "testcompany.sshlqf.com" : "company.sshlqf.com")}/floor-preload?tokens=${res.access_token}`;
      //   } else {
      //     url = `${location.protocol}//${location.host}/floor-preload?tokens=${res.access_token}`;
      //   }
      // }
      let host = "";
      let url = "";
      // 区分运行环境是本地或线上
      if (location.host.includes('172.20') || location.host.includes('192.168')) {
        host = this.ruleForm.mall_type === '4' ? `${location.hostname}:6605` : `${location.host}/floor-preload`;
        url = `${location.protocol}//${host}?tokens=${res.access_token}`;
      } else {
        host = this.ruleForm.mall_type === '4' ? `${location.host.replace('group', 'aicards')}` : `${location.host}/floor-preload`;
        url = `${location.protocol}//${host}?tokens=${res.access_token}`;
      }
      // console.log(url);
      const p = `${this.activeTabName}_${item.shop_id}`
      url.includes('?') ? url += `&fr=${p}` : url += `?fr=${p}`
      debugger
      window.open(`${url}`);
    });
  }

  preview (item) {
    // 预览
    this.mallPreviewShow = true;
    this.mallPreviewLink = `${this.headUrl}${item.domain_name}${this.$url}`;
  }

  copyShop (item) {
    console.log(item.shop_type)
    if (item.shop_type === 1) {
      console.log(111)
      if (this.storeNum !== -1 && this.storeNum <= this.listData.length) {
        this.$message.error('您的企业创建商城数已达到上限，如想增加商城数，请先进行企业升级')
      } else {
        this.isMaxShopNum()
          .then(() => {
            this.copyDialogVisible = true;
            this.ruleForm.shop_id = item.shop_id;
            this.ruleForm.company_img = item.company_img;
          })
          .catch((e) => {
            this.$message.error(e.message);
          });
      }
    } else {
      if (item.shop_type === 4 && this.packageStoreNum !== -1 && this.packageStoreNum <= this.listData.length) {
        this.$message.error('您的企业创建商城数已达到上限，如想增加商城数，请先进行企业升级')
      } else {
        this.isMaxShopNum()
          .then(() => {
            this.copyDialogVisible = true;
            this.ruleForm.shop_id = item.shop_id;
            this.ruleForm.company_img = item.company_img;
          })
          .catch((e) => {
            this.$message.error(e.message);
          });
      }
    }
  }

  handleBeforeClose () {
    this.$refs.ruleForm.resetFields();
    this.$refs.ruleForm.clearValidate();
    this.copyDialogVisible = false;
  }

  handleCopyShop () {
    this.$refs.ruleForm.validate((valid) => {
      if (valid) {
        // 所有表单校验通过  进行验证  执行下一步不
        const data = JSON.parse(JSON.stringify(this.ruleForm));
        // data.domain_name = this.activeTabName === 'cashShop' ? data.domain_name : 'combo-' + data.domain_name
        if (this.activeTabName !== 'cashShop') {
          if (this.activeTabName !== 'comboCardShop2') {
            data.domain_name = 'combo-' + data.domain_name
          } else {
            data.domain_name = 'ai-' + data.domain_name
          }
        }
        console.log(data)
        if (data.password) {
          data.password = md5(data.password);
        }

        if (data.regionValue) {
          data.region = data.regionValue[data.regionValue.length - 1];
          delete data.regionValue;
        }
        if (data.mall_type === "4") {
          API_MallManageMent.copyShopTh(data).then(() => {
            this.$refs.ruleForm.resetFields();
            this.$refs.ruleForm.clearValidate();
            this.copyDialogVisible = false;
            this.getShopList();
          }).catch(() => {
          });
        } else {
          API_MallManageMent.copyShop(data).then(() => {
            this.$refs.ruleForm.resetFields();
            this.$refs.ruleForm.clearValidate();
            this.copyDialogVisible = false;
            this.getShopList();
          }).catch(() => {
          });
        }
      }
    });
  }

  isMaxShopNum () {
    return new Promise((resolve, reject) => {
      API_Shop.checkShopLv().then((res) => {
        if (res.data.isStore === "1") {
          resolve();
        } else {
          reject(
            new Error(
              "您的企业创建商城数已达到上限，如想增加商城数，请先进行企业升级"
            )
          );
        }
      });
    });
  }

  loadCopyTask () {
    clearInterval(this.copyTaskTimer);
    // 判断是否有复制任务 true 前台可以进行复制操作 false 前台不能进行复制操作
    this.copyTaskTimer = setInterval(() => {
      const apiKey = this.activeTabName === "cashShop"
        ? "checkCopyShop"
        : "checkCopyShopCombo";

      API_MallManageMent[apiKey]().then((res) => {
        if (!res) {
          this.listData[this.listData.length - 1]["isCoping"] = true;
        } else {
          this.listData[this.listData.length - 1]["isCoping"] = false;
          clearInterval(this.copyTaskTimer);
        }
      });
    }, 1000);
  }

  genDomainName () {
    if (this.ruleForm.shop_name.trim()) {
      this.ruleForm.domain_name =
        pinyin(this.ruleForm.shop_name, {
          toneType: "none",
          type: "array",
        })
          .map((v) => v.substring(0, 1))
          .join("") + Math.round(Math.random() * 10000);
      this.ruleForm.domain_name = this.ruleForm.domain_name.split('-').join("").split('！').join("")
    } else {
      this.ruleForm.domain_name = "";
    }
    // if (this.activeTabName !== 'cashShop') {
    //   this.ruleForm.domain_name = 'combo-' + this.ruleForm.domain_name;
    // }
    this.ruleForm.domain_name = this.ruleForm.domain_name.toLowerCase();
  }
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

::v-deep {
  .el-tabs {
    transform: translateY(8px);
  }

  .el-tabs__header {
    margin-bottom: 0;
  }

  .el-tabs__nav {
    margin: 0;
  }
}

.shop-management {
  overflow: hidden;
  background: #fff;

  .tools-bar-wrap {
    padding: 20px;
    padding-bottom: 0;
  }

  .shoppingList {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;

    .shopingItem {
      width: 25%;
      padding: 10px;
      position: relative;

      &>div {
        width: 100%;
        height: 100%;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0px 0px 15px 1px #96969645;
      }

      .is-coping-overlay {
        background: rgba($color: #000000, $alpha: 0.8);
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 2%;
        left: 2%;
        width: 96%;
        height: 96%;
        padding: 20px;
        z-index: 999;
        color: #fff;
        font-size: 16px;
      }

      .is-coping-progress-bar {
        position: absolute;
        bottom: 2%;
        left: 2%;
        width: 96%;
        height: 15px;
        background-color: #fff;
        border-radius: 5px;
        z-index: 1000;

        &::after {
          content: " ";
          display: block;
          width: 12%;
          height: 100%;
          background-image: linear-gradient(60deg,
              transparent 0,
              transparent 0.8rem,
              #4dafe2 0.8rem,
              #4dafe2 1.6rem,
              transparent 1.6rem,
              transparent 2.4rem,
              #4dafe2 2.4rem);
        }
      }

      .online-tag {
        width: 60px;
        height: 22px;
        color: #fff;
        font-size: 14px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 8px 2px 2px 2px;
        background-color: #009ed6;
        position: absolute;
        z-index: 99;
        top: 2.5%;
        left: 3%;

        &.disable {
          background-color: rgb(201, 201, 201);
        }
      }
    }

    .top {
      width: 100%;
      height: 180px;
      border-radius: 8px;
      overflow: hidden;
      position: relative;

      .img {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
        }
      }

      .qr {
        position: absolute;
        left: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.5);
        width: 100%;
        height: 100%;
        display: -webkit-flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        color: #fff;

        img {
          width: 120px;
          height: 120px;
        }
      }
    }

    .bot {
      width: 100%;
      padding: 15px 15px 10px 15px;
      display: -webkit-flex;
      flex-direction: column;
      justify-content: space-between;

      .tit {
        text-align: left;
        font-weight: bolder;
        font-size: 18px;
        width: 80%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        padding-bottom: 10px;
      }

      .sub-tit {
        text-align: left;
        font-size: 12px;
        color: #9c9c9c;
        width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        padding-bottom: 10px;
      }

      .statics-wrap {
        font-size: 14px;
        color: #6d6d6d;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .statics-item {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;

          &>div+div {
            color: red;
          }
        }
      }

      .btns-wrap {
        font-size: 14px;
        color: #6d6d6d;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .btns-item {
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          align-items: center;
          cursor: pointer;

          &>div:first-child {
            margin-bottom: 2px;
            width: 28px;
            height: 28px;

            img {
              width: 26px;
            }
          }
        }
      }
    }

    .bot-btns {
      background-color: #f4f4f4;
      padding: 10px 15px 5px 15px;
    }
  }
}

.mall-wrap {
  text-align: center;
  height: 600px;
}

.mall-preview {
  border: 1px solid #eee;
  margin: 0 auto;
  height: 100%;
  width: 380px;
}

.form {
  .title {
    font-weight: bolder;
    font-size: 22px;
  }

  .content {
    width: 80%;
    margin: 0 auto;
    padding: 10px 0;

    /deep/ .el-form-item {
      margin-bottom: 15px;
    }
  }
}

#spinner {
  display: inline-block;
  height: 1em;
  line-height: 1;
  text-align: left;
  vertical-align: -0.25em;
  overflow: hidden;
}

#spinner::before {
  display: block;
  content: "...\A..\A.";
  white-space: pre-wrap;
  /* 也可以是white-space: pre */
  animation: dot 3s infinite step-start both;
}

@keyframes dot {
  33% {
    transform: translateY(-2em);
  }

  66% {
    transform: translateY(-1em);
  }
}

/deep/ {
  .el-dialog__body {
    padding: 0;
  }
}
</style>
